// src/utils/scoreUtils.js

export const computeOverallScore = (auditData) => {
  let score = 0;

  // Domain Authority
  const da = auditData.domainAuthority;
  if (da != null && da > 0) {
    if (da < 5) score += -5;
    else if (da <= 10) score += -3;
    else if (da <= 20) score += 2;
    else if (da <= 30) score += 3;
    else score += 5;
    console.log("Domain Authority waitage",score)
  }

  // Spam Score
  // score += (auditData.spamScore ?? 99) <= 1 ? 5 : -5;
  // Spam Score — skip if null (unavailable from fallback source)
  const spam = auditData.spamScore;
  if (spam != null) {
    score += spam <= 4 ? 5 : -5;
    console.log("Spam Score waitage ",score)
  }


  // Domain Age — skip if 0 (RDAP/WHOIS failed)
  const age = auditData.domainAgeYears;
  if (age != null && age > 0) {
    if (age <= 2) score += -5;
    else if (age <= 5) score += -2;
    else if (age <= 8) score += 2;
    else score += 5;
    console.log("domain Score waitage ",score)
  }

  // Referring Domains — skip if 0 (OpenPageRank doesn't provide this)
  const rd = auditData.referringDomains;
  if (rd != null && rd > 0) {
    if (rd <= 25) score += -10;
    else if (rd <= 50) score += -5;
    else if (rd <= 100) score += 5;
    else score += 10;

    console.log("refring domain Score waitage ",score)
  }


  // Page Speed Mobile — skip if 0 (not yet loaded)
  const psm = auditData.pageSpeedMobile;
  if (psm != null && psm > 0) {
    if (psm <= 20) score += -10;
    else if (psm <= 40) score += -5;
    else if (psm <= 60) score += 2;
    else if (psm <= 75) score += 5;
    else score += 10;

    console.log("mobile page speed waitage ",score)
  }
 
 // Page Speed Desktop — skip if 0
  const psd = auditData.pageSpeedDesktop;
  if (psd != null && psd > 0) {
    if (psd <= 25) score += -10;
    else if (psd <= 50) score += -5;
    else if (psd <= 75) score += 2;
    else score += 5;

    console.log("desktop page speed waitage ",score)
  }

  // Responsiveness
  if (auditData.isResponsive != null) {
    score += auditData.isResponsive ? 5 : -5;
  }


  // GMB Rating
  const rating = auditData.gmbRating;
  if (rating != null && rating > 0) {
    if (rating < 3.5) score += -5;
    else if (rating <= 4.2) score += -3;
    else if (rating <= 4.8) score += 2;
    else score += 5;
  }


  // Review Count
  const rc = auditData.reviewCount;
  if (rc != null && rc > 0) {
    if (rc < 25) score += -10;
    else if (rc <= 50) score += -5;
    else if (rc <= 100) score += 2;
    else if (rc <= 200) score += 5;
    else score += 10;
  }

  // Review Frequency
  const rf = auditData.daysSinceLastReview;
  if (rf != null) {
    if (rf < 7) score += 5;
    else if (rf < 30) score += 2;
    else if (rf <= 60) score += -2;
    else if (rf <= 120) score += -5;
    else score += -10;
  }

  // Services
  const svc = auditData.servicesCount;
  if (svc != null) {
    if (svc === 0) score += -5;
    else if (svc === 1) score += -4;
    else if (svc < 10) score += 2;
    else score += 5;
  }

  // Technical SEO
  if (auditData.hasSitemap != null)      score += auditData.hasSitemap ? 0 : -2;
  if (auditData.hasRobots != null)       score += auditData.hasRobots ? 0 : -2;
  if (auditData.hasBrokenLinks != null)  score += auditData.hasBrokenLinks ? -2 : 0;
  if (auditData.hasSSL != null)          score += auditData.hasSSL ? 0 : -2;
  //if (auditData.hasRedditAccount != null) score += auditData.hasRedditAccount ? 0 : -2;

  // //Brand Persentation
  // if (!auditData.hasRedditAccount) score += -2;

  // FAQ & Citations
  // if (auditData.hasFAQSchema != null)  score += auditData.hasFAQSchema ? 0 : -5;
  // if (auditData.hasCitations != null)  score += auditData.hasCitations ? 0 : -5;
  console.log("Final Score",score)

  return Math.max(0, Math.min(100, score));
};